import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // Register (or update) the current SW
      const reg = await navigator.serviceWorker.register('/sw.js');
      // Force check for an updated SW (bumps version without waiting for 24h background update)
      await reg.update();
      // If a newer SW is installed but waiting, activate it immediately
      if (reg.waiting) {
        reg.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      // When a new SW takes over, reload once so the fresh bundle loads
      let reloaded = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!reloaded) {
          reloaded = true;
          window.location.reload();
        }
      });
    } catch (_) { /* SW is optional */ }
  });
}
